// material-ui
import { useTheme } from '@mui/material/styles';

import OPNIcon from 'assets/images/OPNIcon-blue.png';
import OPNIconDark from 'assets/images/OPNIcon-white.png';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => {
  const theme = useTheme();

  return (
    <img src={theme.palette.mode === 'dark' ? OPNIconDark : OPNIcon} alt="OPN" width="55" />
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === 'dark' ? logoIconDark : logoIcon} alt="Mantis" width="100" />
     *
     */
  );
};

export default LogoIcon;
